import {
    Box,
    CircularProgress,
    Grid,
    Typography,
    useMediaQuery,
    useTheme,
  } from "@mui/material";
  import { useEffect, useState } from "react";
  import { indexes } from "./Api";
  
  export default function Glossary({
    setSelectedChapter,
    setSelectedAyatNumber,
    navMenuItemClick,
  }) {
    const [isLoading, setIsLoading] = useState(false);
    const [groupedIndexes, setGroupedIndexes] = useState({});
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  
    useEffect(() => {
      setIsLoading(true);
      indexes()
        .then((result) => {
          let idx = result.indexes;
          idx = idx.sort((a, b) =>
            replaceAndLower(a.indexName).localeCompare(
              replaceAndLower(b.indexName),
              "en",
              { sensitivity: "base" }
            )
          );
  
          // Group by first normalized letter
          const grouped = idx.reduce((acc, item) => {
            const letter = replaceAndLower(item.indexName)[0].toUpperCase();
            if (!acc[letter]) acc[letter] = [];
            acc[letter].push(item);
            return acc;
          }, {});
  
          setGroupedIndexes(grouped);
          setIsLoading(false);
        })
        .catch(console.error);
    }, []);
  
    const replaceAndLower = (str) =>
      str
        .toLowerCase()
        .replace(/ā/g, "a")
        .replace(/ḍ/g, "d")
        .replace(/ḥ/g, "h")
        .replace(/ī/g, "i")
        .replace(/ṣ/g, "s")
        .replace(/ṭ/g, "t")
        .replace(/ū/g, "u")
        .replace(/ẓ/g, "z")
        .replace(/'/g, "")
        .replace(/ʿ/g, "")
        .replace(/’/g, "");
  
    const sortedLetters = Object.keys(groupedIndexes).sort();
  
    const handleScrollToLetter = (letter) => {
      const section = document.getElementById(`letter-${letter}`);
      if (section) {
        section.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };
  
    return (
      <>
        <Box
          alignItems="center"
          mt={12}
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >

             {/* Fixed vertical A–Z index bar */}
    
           <Box
           sx={{
             display: 'flex',
             flexWrap: 'wrap',
             gap: 1,
             mb: 3,
             justifyContent: 'center',
           }}
         >
            {sortedLetters.map((letter) => (
                <Typography
                            key={letter}
                            variant="default_body"
                            sx={{
                              cursor: 'pointer',
                              px: 1,
                         
                              textDecoration: 'underline',
                            }}
                onClick={() => handleScrollToLetter(letter)}
              >
              <b>{letter}</b> 
              </Typography>
            ))}
          </Box>
      

          <Box px={isSmallScreen ? 2 : 5} pt={4}>
            {isLoading ? (
              <CircularProgress color="text" />
            ) : (
              sortedLetters.map((letter) => (
                <div key={letter} id={`letter-${letter}`}>
                  <Typography
                    variant="appBarTitle"
                    sx={{ mt: 4, mb: 2, fontWeight: "bold" }}
                  >
                    {letter}
                  </Typography>
  
                  <Grid container spacing={2}>
                    {groupedIndexes[letter].map((item, index) => (
                      <Grid
                        item
                        xs={4}
                        key={index}
                        onClick={() => console.log(item.indexName)}
                      >
                        <Typography variant="default_body">
                          {item.indexName}
                        </Typography>
  
                        {item.refrences.map((ref2, i) => (

                                                                        <>
                                                <span style={{ fontSize: 12, cursor: "pointer", color: "#0280CD" }} onClick={() =>
                                                (
                                                    setSelectedChapter({
                                                        id: ref2.number,
                                                        number: ref2.number,
                                                        title: ref2.chapterTitle,
                                                        arabicTitle: ref2.chapterArabicTitle,
                                                        totalAyats: ref2.totalAyats
                                                    },
                                                        setSelectedAyatNumber(ref2.ayatNumber)
                                                    )
                                                    , navMenuItemClick("read"))}> 
                                                    [{ref2.number}:{ref2.ayatNumber}]
                                                 </span>
                                            </>
                  
                        ))}
                      </Grid>
                    ))}
                  </Grid>
                </div>
              ))
            )}
          </Box>
        </Box>
  
       
      </>
    );
  }